var map = {
	"./background/background-old.jpg": 3165,
	"./background/background.jpg": 3833,
	"./background/background.png": 1921,
	"./background/background1.jpg": 9064,
	"./sample/sample1.png": 5488,
	"./sample/sample2.png": 9307,
	"./sample/sample3.png": 5154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7601;